"use client"

import { ReactNode, useMemo } from "react"
import { NextIntlClientProvider } from "next-intl"

import { getSbLocaleFromHostAndUri } from "@/lib/locale-helper"
import { getIsoLocaleFromSbLocale } from "@/lib/locale/locale-common-utils"
import { getNextIntlLocaleFromIsoLocale } from "@/lib/market/market"

import deCh from "../../../messages/de-ch.json"
import de from "../../../messages/de.json"
import en from "../../../messages/en.json"
import frBe from "../../../messages/fr-be.json"
import frCh from "../../../messages/fr-ch.json"
import fr from "../../../messages/fr.json"
import it from "../../../messages/it.json"
import nlBe from "../../../messages/nl-be.json"
import nl from "../../../messages/nl.json"

const messagesByLocale: Record<string, any> = {
  de,
  "de-at": de,
  "de-ch": deCh,
  en,
  fr,
  "fr-be": frBe,
  "fr-ch": frCh,
  it,
  nl,
  "nl-be": nlBe,
}

function getClientLocale() {
  if (typeof window === "undefined") {
    return "de"
  }

  const sbLocale = getSbLocaleFromHostAndUri(window.location.hostname, window.location.pathname)
  const isoLocale = getIsoLocaleFromSbLocale(sbLocale)
  return getNextIntlLocaleFromIsoLocale(isoLocale)
}

export default function RootIntlFallbackProvider({ children }: { children: ReactNode }) {
  const locale = useMemo(() => getClientLocale(), [])
  const messages = messagesByLocale[locale] ?? messagesByLocale.de

  return (
    <NextIntlClientProvider locale={locale} messages={messages}>
      {children}
    </NextIntlClientProvider>
  )
}
